import DeviceInfo from './device-info/index'
import Vue from 'vue'

Vue.use(DeviceInfo)
